
import {PropType, SetupContext, toRefs} from "vue";

export default {
  name: "Filtering",
  emits: ['update:selected'],
  props: {
    title: {
      type: String,
      require: true,
    },
    options: {
      type: Array as PropType<string[]>,
      require: true
    },
    selected: {
      type: Number,
      default: 0,
      require: true,
    }
  },
  setup(props: any, {emit}: SetupContext) {
    const {options} = toRefs(props);

    const onChange = (event: Event) => {
      const value = (event.target as any)?.value;
      // console.log(value, options.value?.findIndex((o: string) => o === value));
      emit("update:selected", options.value?.findIndex((o: string) => o === value));
    }


    const onSelected = (index: number) => {
      emit("update:selected", index);
    }

    return {
      onSelected,
      onChange

    }
  }
}
